var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { createUIElement } from "../../helpers";
import { Section } from './Section';
import { APP_LAYOUT_ALIGN } from "./types";
var BodySection = styled(Section)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    align-items: ", ";\n    align-self: stretch;\n"], ["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    align-items: ", ";\n    align-self: stretch;\n"])), function (_a) {
    var align = _a.align;
    return align || 'stretch';
});
var FooterSection = styled(Section)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    align-items: stretch;\n    align-self: stretch;\n    justify-content: flex-end;\n"], ["\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    flex-shrink: 0;\n    flex-grow: 1;\n    align-items: stretch;\n    align-self: stretch;\n    justify-content: flex-end;\n"])));
var SpaceFill = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: ", ";\n    align-self: stretch;\n"], ["\n    display: flex;\n    flex-grow: ", ";\n    align-self: stretch;\n"])), function (_a) {
    var grow = _a.grow;
    return grow;
});
export var AppLayoutBody = createUIElement('AppLayoutBody', function (_a, ref) {
    var className = _a.className, _b = _a.align, align = _b === void 0 ? APP_LAYOUT_ALIGN.fill : _b, children = _a.children, body = _a.body, footer = _a.footer, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "align", "children", "body", "footer", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var content = body || children;
    return (React.createElement(BodySection, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'app-layout-body', className: "vm-AppLayoutBody " + className, align: align === APP_LAYOUT_ALIGN.fill ? 'stretch' : 'center', onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), content && (React.createElement(React.Fragment, null,
        align !== APP_LAYOUT_ALIGN.fill && React.createElement(SpaceFill, { grow: 1 }),
        content,
        align !== APP_LAYOUT_ALIGN.fill && (React.createElement(SpaceFill, { grow: align === APP_LAYOUT_ALIGN.raised ? 2 : 1 })),
        !!footer && React.createElement(FooterSection, null, footer)))));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AppLayoutBody.js.map